import styles from './index.module.css'

import React, { useMemo, useCallback } from 'react'

import type { TrackOptions } from '@disco/state-management/actions/MediaActions'
import { setTrackMediaEventProperties } from '@disco/state-management/actions/MediaActions'
import { getDiscoverPlayAudioMixpanelProperties } from '@disco/utils/mixpanel/discover-page'

import type { Track } from 'types/track'

import MediaOverlay from 'components/common/media-overlay'
import TrackArtwork from 'components/common/tracks/track-artwork'
import { Box } from 'components/ds'
import { HoverProvider } from 'components/ui/hover-provider'

import { useDispatch } from 'hooks/use-redux'

type Props = {
  track: Track
  playbackContext: TrackOptions
  size: string
  onClick?: () => void
  businessName?: string
}

const AudioArtworkBtn = ({
  track,
  playbackContext,
  size,
  businessName,
}: Props) => {
  const dispatch = useDispatch()
  const trackMediaProperties = useMemo(
    () =>
      getDiscoverPlayAudioMixpanelProperties({
        trackId: track.id,
        catalogBusiness: businessName || 'Unknown',
        catalogId: playbackContext.catalog?.id,
        catalogName:
          playbackContext.catalog?.display_name || 'Untitled Catalog',
        context: 'Preview Tracks' as const,
      }),
    [
      track.id,
      businessName,
      playbackContext.catalog?.id,
      playbackContext.catalog?.display_name,
    ],
  )

  const handleClick = useCallback(() => {
    dispatch(
      setTrackMediaEventProperties({
        trackId: track.id,
        properties: trackMediaProperties,
      }),
    )
  }, [dispatch, track.id, trackMediaProperties])

  return (
    <HoverProvider>
      <Box width={size} height={size} className={styles.trackArtworkBox}>
        <MediaOverlay
          track={track}
          mediaSource="in-app"
          location="discover-music-home"
          playbackContext={playbackContext}
          iconSize={12}
          clickEvent={handleClick}
        >
          <TrackArtwork track={track} size="160" />
        </MediaOverlay>
      </Box>
    </HoverProvider>
  )
}

export default AudioArtworkBtn
